import { render, staticRenderFns } from "./PageDataRoot.vue?vue&type=template&id=86ca8a58&"
import script from "./PageDataRoot.vue?vue&type=script&lang=js&"
export * from "./PageDataRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports